import * as React from 'react';
import { RocketLaunchIcon } from '@heroicons/react/24/solid';

export const Badge: React.FC = () => {
  return (
    <div className="flex items-center bg-white text-orange-900 px-1 space-x-0.5 rounded border border-orange-900">
      <RocketLaunchIcon style={{ height: 14 }} color="text-orange-900" />
      <h5>Beta</h5>
    </div>
  );
};
Badge.displayName = 'Shipments.Beta.Badge';
